import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=2c011053&"
import script from "./Facilities.vue?vue&type=script&lang=js&"
export * from "./Facilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports